import React from 'react';
import ReportsScreen from '../../screens/ReportsScreen';

export const ReportsScreenConnector = () => <ReportsScreen />;

export default ReportsScreenConnector;
